/*
 * @Author:
 * @LastEditTime: 2022-03-17 15:21:08
 * @Description:
 */
import To from 'await-to-js'
import Callback from '@/assets/js/api/callback'

const request = async (
  arg = {
    method: 'get',
    url: '',
    data: {},
  }
) => {
  // let [err, res] = [null, null]
  const config = {}
  if (arg.config) {
    _.assign(config, arg.config)
  }
  const instance = axios.create(config)
  const currentEnv = Wiz.GetModuleConfig('legacy-resource').currentEnv
  instance.defaults.baseURL = currentEnv.VUE_APP_STANDARD_SERVER
  const [err, res] = await To(
    instance({
      url: arg.url,
      method: arg.method,
      data: arg.data,
    })
  )
  // switch (arg.method) {
  //   case 'post':
  //     ;[err, res] = await To(instance.post(arg.url, arg.data))
  //     break
  //   case 'patch':
  //     ;[err, res] = await To(instance.patch(arg.url, arg.data))
  //     break
  //   default:
  //     ;[err, res] = await To(instance.get(arg.url))
  // }
  return Callback.globalCBForOld(err, res)
}

export default request
